import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginScreen } from '../components/login/LoginScreen';
import { RegistroScreen } from '../components/login/RegistroScreen';
import { RecoveryScreen } from '../components/login/RecoveryScreen';
import { Error404Screen } from '../components/feedback/Error404Screen';
import { VerifyEmailScreen } from '../components/login/VerifyEmailScreen';
import { useLocalizedRoutes } from '../hooks/useLocalizedRoutes';

export const PublicRoutes = () => {
  const { getPath } = useLocalizedRoutes();

  return (
    <Routes>
      <Route path='/' element={<Navigate to={getPath('login')} replace />} />
      <Route path={getPath('login')} element={<LoginScreen />} />
      <Route path={getPath('register')} element={<RegistroScreen />} />
      <Route
        path={getPath('registerVerify')}
        element={<VerifyEmailScreen />}
      />
      <Route path={getPath('recovery')} element={<RecoveryScreen />} />
      <Route path={getPath('notFound')} element={<Error404Screen />} />
      <Route path='*' element={<Navigate to={getPath('login')} replace />} />
    </Routes>
  );
};
